import './styles/App.css';
import { TableUI } from './components/vacuum';
import { VacuumAlloy, VacuumCategory } from './components/core/alloy-types';

function processAirtableVacuumRecords(r: any): VacuumAlloy {
  const vacuumAlloy: VacuumAlloy = {
    id: r.fields['id'] as number, 
    category: r.fields['category'] as VacuumCategory,
    cannonMuskegonTitle: r.fields['cannonMuskegonTitle'] as string,
    aerospaceMaterialSpecifications: r.fields['aerospaceMaterialSpecifications'] as string,
    prattAndWhitney: r.fields['prattAndWhitney'] as string,
    generalElectric: r.fields['generalElectric'] as string,
    rollsRoycePlc: r.fields['rollsRoycePlc'] as string,
    rollsRoyceCorp: r.fields['rollsRoyceCorp'] as string,
    honeywell: r.fields['honeywell'] as string,
    safran: r.fields['safran'] as string,
    aluminum: r.fields['aluminum'] as any,
    boron: r.fields['boron'] as any,
    carbon: r.fields['carbon'] as any,
    chromium: r.fields['chromium'] as any,
    cobalt: r.fields['cobalt'] as any,
    hafnium: r.fields['hafnium'] as any,
    iron: r.fields['iron'] as any,
    niobium: r.fields['niobium'] as any,
    rhenium: r.fields['rhenium'] as any,
    tantalum: r.fields['tantalum'] as any,
    titanium: r.fields['titanium'] as any,
    tungsten: r.fields['tungsten'] as any,
    zirconium: r.fields['zirconium'] as any,
    densityImperial: r.fields['densityImperial'] as any,
    densityMetric: r.fields['densityMetric'] as any,
    other: r.fields['other'] as any,
    solidusF: r.fields['solidusF'] as any,
    liquidousF: r.fields['liquidousF'] as any,
    solidusC: r.fields['solidusC'] as any,
    liquidousC: r.fields['liquidousC'] as any,
  };

  return vacuumAlloy;
}

function VacuumPage(props: any) {
  const { records } = props;

  var vacuumAlloys: VacuumAlloy[] = records.map((a: any) => processAirtableVacuumRecords(a));

  return (
    <div className="App">
      <TableUI products={vacuumAlloys}/> 
    </div>
  );
}

export default VacuumPage;
